<template>
    <section class="main-box-vc">
        <div class="table-cell">
            <div class="main-box">
                <div class="main-box-content">
                    <h3>BRICKS <span>for</span> BULLS</h3>
                    <h4>Building memories, one brick at a time.</h4>
                    <router-link to="/about" class="btn btn-danger-inverse">GET STARTED</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    export default {
        name: 'home'
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Home.vue?04687934